import { ActionRecord } from '../../lib/types'
import auth from '../../lib/auth'

export type ReviewStats = {
    total: number
    approvals: number
    approvalsPct: number
    yourApprovals: number
    yourApprovalsPct: number
}

export default function calculateStats(
    total: number,
    reviews: Array<ActionRecord>,
): ReviewStats | null {
    if (!total) return null

    let yourReviews = reviews.filter((r) => r.userId === Number(auth.user?.sub))
    return {
        total,
        approvals: reviews.length,
        approvalsPct: Math.round((reviews.length / total) * 1000) / 10,
        yourApprovals: yourReviews.length,
        yourApprovalsPct: Math.round((yourReviews.length / total) * 1000) / 10,
    }
}
